<template>
  <MyModal
    title="集电线路部署"
    height="auto"
    v-if="isShow"
    @closeClick="handleCloseModalClick"
  >
    <div class="line-content">
      <div class="form-area">
        <div class="form-item">
          <div class="key">单一回路容量限制</div>
          <div class="value">
            <StandInput
              v-model="form.cap"
              :onlyNumber="true"
              unit="MW"
            ></StandInput>
          </div>
        </div>
        <div class="form-item sp">
          <el-radio-group
            v-model="form.type"
            @change="handleRadioChange"
            :disabled="specificChangeFlag"
          >
            <el-radio label="1">架空</el-radio>
            <el-radio label="2">埋地</el-radio>
          </el-radio-group>
        </div>
      </div>
      <!-- <div v-if="specificChangeFlag && form.type === '2'" class="save-area">
        <el-button type="success" plain @click="handleSave">保存结果</el-button>
      </div> -->
      <div class="btn-area">
        <ct-button type="primary" :btnClick="handleDeployClick"
          >开始部署</ct-button
        >
      </div>
      <div class="list-area" v-if="windfarmWireList.length">
        <div
          v-for="(item, index) in windfarmWireList"
          :key="index"
          class="list-item"
        >
          <div
            class="color-tips"
            :style="{ backgroundColor: getColors(index) }"
          ></div>
          <el-tag>回路{{ 'L' + (index + 1) }}</el-tag>
          <el-divider direction="vertical"></el-divider>
          <el-tag>线路长度{{ toFixed(item.wireLength, 2) }} 米</el-tag>

          <template v-if="!item.isEdit">
            <i
              @click="handleSetChangeStatus(item)"
              :class="[
                'el-icon-edit',
                'icon',
                {
                  'is-active': item.isEdit
                }
              ]"
            ></i>
          </template>

          <template v-else>
            <i
              class="el-icon-check icon"
              @click="handleSaveItemClick(item)"
            ></i>
            <i
              class="el-icon-close icon"
              @click="handleSetChangeStatus(item)"
            ></i>
          </template>

          <i
            :class="[
              'el-icon-view',
              {
                'is-active': item.isShow
              }
            ]"
            @click="handleViewSyzClick(item, index)"
          ></i>
        </div>
      </div>
    </div>
  </MyModal>
</template>

<script>
import StandInput from '../stand-input';
import MyModal from '../modal';
import { mapGetters, mapState } from 'vuex';
import { toFixed, findDeepByAttr } from '../utils';

const COLORS = [
  '#91ca8c',
  '#ffaf51',
  '#ffee51',
  '#8c6ac4',
  '#715c87',
  '#e69d87',
  '#8dc1a9',
  '#ea7e53',
  '#eedd78',
  '#73a373',
  '#73b9bc'
];
export default {
  components: {
    MyModal,
    StandInput
  },
  data() {
    return {
      isShow: true,
      num: '',
      form: {
        cap: '',
        type: '',
        windfarmId: ''
      },
      tempWire: null
    };
  },

  watch: {
    windfarmWireForm: {
      handler(val) {
        this.form.cap = val.cap;
        this.form.type = val.type;
      },
      immediate: true
    },
    form: {
      handler(val) {
        this.$store.commit('WindFarm/SET_WIRE_FORM', {
          cap: val.cap,
          type: val.type
        });
      },
      deep: true
    }
  },

  created() {
    this.$store.commit('WindFarm/SET_INLINEPAGE', true);
    this.$store.commit('WindFarm/UPDATE_TUILIST');
  },
  mounted() {},
  beforeDestroy() {
    this.$store.commit('WindFarm/SET_INLINEPAGE', false);
    this.$store.commit('WindFarm/UPDATE_TUILIST');
    sessionStorage.removeItem('temp_polyGroup');
  },
  computed: {
    ...mapGetters('WindFarm', [
      'windfarmWireForm',
      'specificChangeFlag',
      'windfarmWireList',
      'mapData',
      'polylinesIndexs'
    ]),
    ...mapState('WindFarm', ['mapData'])
  },
  methods: {
    handleSaveItemClick(item) {
      if (this.windfarmWireForm.type === '1') {
        const markersIndex = JSON.parse(
          sessionStorage.getItem('JIAKLONG_MARKERS')
        );

        const { markers } = this.mapData;
        const myMarkers = markersIndex.map(i => markers[i]);

        const ids = myMarkers.map(i => i.gantaId).join(',');
        const lats = myMarkers.map(i => i.lat).join(',');
        const lons = myMarkers.map(i => i.lng).join(',');

        this.$postForm('/windfarm/windfarm/updateRoadTower', {
          data: {
            ids,
            lats,
            lons,
            windfarmId: this.$route.query.windfarmId
          },
          showLoading: true,
          showSuccess: true,
          showError: true
        }).then(() => {
          this.$store.commit('WindFarm/SET_specificChangeFlag', false);

          this.$store.dispatch('WindFarm/getWindFarmWire', {
            params: {
              type: '1',
              windfarmId: this.$route.query.windfarmId
            }
          });
        });
      } else {
        item.isEdit = false;
        this.handleSave();
      }
    },
    handleSetChangeStatus(item) {
      if (this.windfarmWireForm.type === '1') {
        if (!item.isEdit) {
          if (this.specificChangeFlag) {
            return this.$message.warning('不能同时修改多条架空回路');
          }

          item.isEdit = true;
          this.$store.commit('WindFarm/SET_specificChangeFlag', true);
          this.$store.commit('WindFarm/UPDATE_GANTALIST', {
            circuit: item.circuit,
            callback: () => {
              this.$nextTick(() => {
                this.$bus.$emit('getMapInstance', instance => {
                  this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
                    type: 'gantaPoint',
                    mapInstance: instance,
                    filter: () => true,
                    status: true,
                    key: 'specificChangeFlag'
                  });
                });
              });
            }
          });
        } else {
          item.isEdit = false;
          this.$store.commit('WindFarm/SET_specificChangeFlag', false);
          this.$store.commit('WindFarm/UPDATE_GANTALIST');
          this.$bus.$emit('clearHasDragControl');
        }
      } else {
        // 埋地
        if (!item.isEdit) {
          if (this.specificChangeFlag) {
            return this.$message.warning('不能同时修改多条埋地回路');
          }
          item.isEdit = true;

          this.$bus.$emit('getMapInstance', instance => {
            this.$store.commit('WindFarm/SET_LINE_EDIT', {
              type: 'wirelist',
              mapInstance: instance,
              update: () => {},
              key: 'specificChangeFlag'
            });
          });

          const { polylines } = this.mapData;

          let _index = [];
          polylines.forEach((line, index) => {
            const thisItemWireId = findDeepByAttr(line, 'wireId');

            if (thisItemWireId === item.wireId) {
              _index.push(index);
            }
          });

          polylines.forEach((item, index) => {
            if (_index.includes(index)) {
              this.$bus.$emit('getMapInstance', mapInstance => {
                if (!mapInstance.shapes.polylines[index].pm.enabled()) {
                  mapInstance.shapes.polylines[index].pm.toggleEdit();
                }
              });
            } else {
              this.$bus.$emit('getMapInstance', mapInstance => {
                if (mapInstance.shapes.polylines[index].pm.enabled()) {
                  mapInstance.shapes.polylines[index].pm.toggleEdit();
                }
              });
            }
          });
        } else {
          item.isEdit = false;
          this.$store.commit('WindFarm/SET_specificChangeFlag', false);
          this.$store.commit('WindFarm/SET_RAW_LINE', {
            type: 'wirelist',
            data: []
          });
          this.$store.commit('WindFarm/SET_LINE', []);
          this.$store.commit('WindFarm/UPDATE_ROAD_LIST');
          const { polylines } = this.mapData;

          polylines.forEach((item, index) => {
            this.$bus.$emit('getMapInstance', mapInstance => {
              if (mapInstance.shapes.polylines[index].pm.enabled()) {
                mapInstance.shapes.polylines[index].pm.toggleEdit();
              }
            });
          });

          sessionStorage.removeItem('temp_polyGroup');

          this.$store.dispatch('WindFarm/getWindFarmWire', {
            params: {
              type: this.windfarmWireForm.type,
              windfarmId: this.$route.query.windfarmId
            },
            usePrevShow: true
          });
        }
      }
    },
    getColors(index) {
      return COLORS[index % COLORS.length];
    },
    toFixed,
    handleViewSyzClick(item) {
      if (item.isEdit && item.isShow) {
        return this.$message.warning('调整中的线路不可隐藏');
      }

      if (this.windfarmWireForm.type === '2') {
        const tempPolyLineStr = sessionStorage.getItem('temp_polyGroup');

        if (!tempPolyLineStr) {
          const newArr = [...this.windfarmWireList];

          const arr = newArr.map(i => {
            if (i.wireId === item.wireId) {
              return {
                ...i,
                isShow: !i.isShow
              };
            } else {
              return { ...i };
            }
          });
          this.$store.commit('WindFarm/SET_WIRE_LIST', arr);
          this.$store.commit('WindFarm/UPDATE_WIRE_LIST');
          return;
        }
        const tempPolyLine = JSON.parse(tempPolyLineStr);

        const lines = this.mapData.polylines.filter((item, index) => {
          return this.polylinesIndexs.includes(index);
        });

        const tempLines = tempPolyLine.filter((item, index) => {
          return this.polylinesIndexs.includes(index);
        });

        let myArr = [];
        lines.forEach((editLine, index) => {
          const rawIndex = tempLines[index][0]?.index;
          if (!myArr[rawIndex]) {
            myArr[rawIndex] = [editLine];
          } else {
            myArr[rawIndex].push(editLine);
          }
        });

        const typeArrString = sessionStorage.getItem('CURRENT_JSONTYPE');

        const typeArr = JSON.parse(typeArrString);

        const thisArr = this.windfarmWireList
          .filter(i => !!i.isShow)
          .map((i, index) => {
            return {
              wireId: i.wireId,
              wireSection: JSON.stringify({
                type: typeArr[index],
                coordinates:
                  typeArr[index] === 'MultiLineString'
                    ? myArr[index].map(i => i.map(a => [a.lng, a.lat]))
                    : myArr[index].map(i => i.map(a => [a.lng, a.lat]))[0]
              })
            };
          });

        const handledArr = thisArr.map(item => {
          const findItem = this.windfarmWireList.find(wire => {
            return item.wireId === wire.wireId;
          });

          return {
            ...findItem,
            ...item
          };
        });

        const newArr = [...this.windfarmWireList];

        const arr = newArr.map(i => {
          const exist = handledArr.find(wire => {
            return wire.wireId === i.wireId;
          });

          if (i.wireId === item.wireId) {
            if (exist) {
              return {
                ...exist,
                isShow: !i.isShow
              };
            } else {
              return {
                ...i,
                isShow: !i.isShow
              };
            }
          } else {
            if (exist) {
              return {
                ...exist
              };
            } else {
              return { ...i };
            }
          }
        });

        this.$store.commit('WindFarm/SET_WIRE_LIST', arr);
        this.$store.commit('WindFarm/UPDATE_WIRE_LIST');

        const editItem = this.windfarmWireList.find(i => i.isEdit) || {};

        if (this.specificChangeFlag) {
          this.$bus.$emit('getMapInstance', instance => {
            this.$store.commit('WindFarm/SET_LINE_EDIT', {
              type: 'wirelist',
              mapInstance: instance,
              update: () => {},
              key: 'specificChangeFlag',
              force: true
            });
          });

          this.$nextTick(() => {
            const { polylines } = this.mapData;

            let _index = [];

            polylines.forEach((line, index) => {
              const thisItemWireId = findDeepByAttr(line, 'wireId');

              if (thisItemWireId === editItem?.wireId) {
                _index.push(index);
              }
            });

            polylines.forEach((item, index) => {
              if (_index.includes(index)) {
                this.$bus.$emit('getMapInstance', mapInstance => {
                  if (!mapInstance.shapes.polylines[index].pm.enabled()) {
                    mapInstance.shapes.polylines[index].pm.toggleEdit();
                  }
                });
              } else {
                this.$bus.$emit('getMapInstance', mapInstance => {
                  if (mapInstance.shapes.polylines[index].pm.enabled()) {
                    mapInstance.shapes.polylines[index].pm.toggleEdit();
                  }
                });
              }
            });
          });
        }
      } else {
        const newArr = [...this.windfarmWireList];

        const arr = newArr.map(i => {
          if (i.wireId === item.wireId) {
            return {
              ...i,
              isShow: !i.isShow
            };
          } else {
            return { ...i };
          }
        });
        this.$store.commit('WindFarm/SET_WIRE_LIST', arr);
        this.$store.commit('WindFarm/UPDATE_WIRE_LIST');
      }

      // if(this.specificChangeFlag) {

      //   const

      // }

      // if (this.specificChangeFlag) {
      //   this.$nextTick(() => {
      //     this.$bus.$emit('getMapInstance', instance => {
      //       this.$store.commit('WindFarm/SET_LINE_EDIT', {
      //         type: 'wirelist',
      //         mapInstance: instance,
      //         key: 'specificChangeFlag',
      //         force: true
      //       });
      //     });
      //   });
      // }
    },
    handleRadioChange(val) {
      this.$store.dispatch('WindFarm/getWindFarmWire', {
        params: {
          type: val,
          windfarmId: this.$route.query.windfarmId
        }
      });

      this.$store.commit('WindFarm/UPDATE_TUILIST');
    },
    handleDeployClick() {
      if (this.form.cap <= 0 || this.form.cap >= 100) {
        return this.$message.warning('单一回路容量限制应大于0，小于100');
      }

      this.$postForm('/windfarm/windfarm/saveWindfarmWire', {
        data: {
          ...this.form,
          windfarmId: this.$route.query.windfarmId
        },
        showLoading: true,
        showError: true,
        showSuccess: true
      }).then(() => {
        this.$store.dispatch('WindFarm/getWindFarmWire', {
          params: {
            type: this.form.type,
            windfarmId: this.$route.query.windfarmId
          }
        });

        this.$store.dispatch('WindFarm/getWindfarmTurbineList', {
          params: {
            windfarmId: this.$route.query.windfarmId
          }
        });
      });
    },
    handleCloseModalClick() {
      this.$bus.$emit('farmClick', 3);
    },
    handleSave() {
      if (this.form.type === '2') {
        const tempPolyLineStr = sessionStorage.getItem('temp_polyGroup');
        const tempPolyLine = JSON.parse(tempPolyLineStr);

        const lines = this.mapData.polylines.filter((item, index) => {
          return this.polylinesIndexs.includes(index);
        });

        const tempLines = tempPolyLine.filter((item, index) => {
          return this.polylinesIndexs.includes(index);
        });

        let myArr = [];
        lines.forEach((editLine, index) => {
          const rawIndex = tempLines[index][0]?.index;
          if (!myArr[rawIndex]) {
            myArr[rawIndex] = [editLine];
          } else {
            myArr[rawIndex].push(editLine);
          }
        });

        const typeArrString = sessionStorage.getItem('CURRENT_JSONTYPE');

        const typeArr = JSON.parse(typeArrString);

        const arr = this.windfarmWireList
          .filter(i => !!i.isShow)
          .map((i, index) => {
            return {
              wireId: i.wireId,
              geometryInfos: JSON.stringify({
                type: typeArr[index],
                coordinates:
                  typeArr[index] === 'MultiLineString'
                    ? myArr[index].map(i => i.map(a => [a.lng, a.lat]))
                    : myArr[index].map(i => i.map(a => [a.lng, a.lat]))[0]
              })
            };
          });

        const wireIds = arr.map(i => i.wireId).join(',');
        const geometryInfos = arr.map(i => i.geometryInfos).join(';');

        this.$postForm('/windfarm/windfarm/updateWindfarmWire', {
          data: {
            windfarmId: this.$route.query.windfarmId,
            wireIds,
            geometryInfos
          },
          showLoading: true,
          showError: true,
          showSuccess: true
        }).then(() => {
          const { polylines } = this.mapData;
          polylines.forEach((i, index) => {
            this.$bus.$emit('getMapInstance', mapInstance => {
              if (mapInstance.shapes.polylines[index].pm.enabled()) {
                mapInstance.shapes.polylines[index].pm.toggleEdit();
              }
            });
          });

          sessionStorage.removeItem('temp_polyGroup');

          this.$store.commit('WindFarm/SET_specificChangeFlag', false);

          this.$store.commit('WindFarm/SET_RAW_LINE', {
            type: 'wirelist',
            data: []
          });
          this.$store.commit('WindFarm/SET_LINE', []);

          this.$store.commit('WindFarm/UPDATE_ROAD_LIST');

          this.$store.dispatch('WindFarm/getWindFarmWire', {
            params: {
              type: this.windfarmWireForm.type,
              windfarmId: this.$route.query.windfarmId
            }
          });
        });
      } else {
        alert('开发中');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.line-content {
  padding: 5px 10px 20px;

  .form-area {
    background-color: #fff;
    margin-top: 10px;
    border-radius: 7px;
    padding: 20px 20px 10px 20px;

    .form-item {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      &.sp {
        margin-top: 15px;
      }
    }

    .key {
      margin-right: 5px;
      width: 150px;
      line-height: 30px;
      font-weight: 500;
    }
    .value {
      width: 120px;
    }
  }
  .btn-area {
    margin-top: 10px;
    text-align: right;
  }
  .save-area {
    text-align: right;
    margin: 10px 0px;
  }
  .list-area {
    background-color: #fff;
    padding: 20px;
    margin-top: 10px;
    border-radius: 7px;
    .list-item {
      margin-top: 10px;
      display: flex;
      align-items: center;
      position: relative;
      .el-icon-view {
        position: absolute;
        right: 0;
        cursor: pointer;
        &.is-active {
          color: #3cc2e6;
        }
      }

      .icon {
        position: absolute;
        right: 25px;
        cursor: pointer;
      }

      .el-icon-close {
        right: 25px;
      }

      .el-icon-check {
        right: 45px;
      }

      .el-icon-edit {
        &.is-active {
          color: #3cc2e6;
        }
      }
      .color-tips {
        height: 5px;
        border-radius: 5px;
        width: 15px;
        margin-right: 10px;
      }
    }
  }
}
</style>
